import { render, staticRenderFns } from "./AlmacenForm.vue?vue&type=template&id=35fa66a0&"
import script from "./AlmacenForm.vue?vue&type=script&lang=js&"
export * from "./AlmacenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports